var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFindADealershipMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41,7H7c-2.7568359,0-5,2.2431641-5,5v24c0,2.7568359,2.2431641,5,5,5h34c2.7568359,0,5-2.2431641,5-5V12 C46,9.2431641,43.7568359,7,41,7z M44,36c0,1.6542969-1.3457031,3-3,3H7c-1.6542969,0-3-1.3457031-3-3V12 c0-1.6542969,1.3457031-3,3-3h34c1.6542969,0,3,1.3457031,3,3V36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0742188,27.5244141C23.5664062,26.9550781,20.5136719,26,17,26s-6.5664062,0.9550781-8.0732422,1.5244141 C7.7744141,27.9589844,7,29.0849609,7,30.3261719V36h2v-5.6738281c0-0.4140625,0.2539062-0.7880859,0.6328125-0.9306641 C11.0126953,28.8740234,13.8046875,28,17,28s5.9873047,0.8740234,7.3681641,1.3955078 C24.7460938,29.5380859,25,29.9121094,25,30.3261719V36h2v-5.6738281C27,29.0849609,26.2255859,27.9589844,25.0742188,27.5244141z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,24c2.8525391,0,5-4.2460938,5-7c0-3.0371094-1.9628906-5-5-5s-5,1.9628906-5,5C12,19.7539062,14.1474609,24,17,24z  M17,14c1.9345703,0,3,1.0654297,3,3c0,2.1025391-1.7382812,5-3,5s-3-2.8974609-3-5C14,15.0654297,15.0654297,14,17,14z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 14,
    width: 12,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 19,
    width: 6,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindADealershipMedium);
export default __webpack_public_path__ + "static/media/find-a-dealership--medium.9eb380fb1e881e35eb0d1bb2cc78df6c.svg";
export { ForwardRef as ReactComponent };